import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=2be8d3bf&scoped=true&"
import script from "./InputRadio.vue?vue&type=script&lang=js&"
export * from "./InputRadio.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/input-radio.scss?vue&type=style&index=0&id=2be8d3bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8d3bf",
  null
  
)

export default component.exports